<template>
    <div class="flex-row card-content">
        <img
            :src="mixin_imgs[getOSSImg(carDetails.carImg)]"
            class="car_img"
        />
        <div class="card-right">
            <span class="title-line">{{ carDetails.name }}</span>
            <div class="flex-row type-line" :style="$route.name=='orderList'?'margin-bottom:0':''">
                <span>{{ carDetails.carTypeLevel }}</span>
                <div class="section_3" v-if="carDetails.carTypePower"><!--*--></div>
                <span>{{ carDetails.carTypePower }}</span>
            </div>
            <div
                v-if="current != 'order'"
                class="flex-row price-line items-baseline"
            >
                <div class="flex-row">
                    <div class="flex-row items-baseline">
                        <span style="color:#333;">定金</span>
                        <span class="text_15 text-red">¥</span>
                        <span class="text_16 text-red">{{ carDetails.presellPrice }}</span>
                    </div>
                    <span class="markIcon" v-if="carDetails.markIcon">可退</span>
                </div>
                <span class="text_20"
                    >指导价: {{ carDetails.officialGuidePrice }}万</span
                >
            </div>
        </div>
    </div>
</template>
<script>
import { getImgMixin } from '../getImg_mixin'
export default {
    props: ["carDetails","current"],
    mixins:[getImgMixin],
    data() {
        return {
            imgUrl:'',
        };
    },
    created(){

    }
};
</script>
<style lang="scss" scoped>
.items-baseline{
    align-items:baseline;
}
.text-red{
    color:#FF3000;
}
.card-content{
    border-radius: 16px;
    padding:24px;
    background:white;
    // background:red;
    img.car_img{
        width:212px;
        height:106px;
        margin-right:24px;
    }
    div.card-right{
        flex:1;
        .title-line{
            font-family: PingFangSC-Medium;
            font-size: 032px;
            color: #141E25;
            font-weight: 500;
            margin-bottom:8px;
            line-height:44px;
        }
        .type-line{
            margin-top:8px;
            font-size:20px;
            margin-bottom:24px;
            span{
                font-family: PingFangSC-Regular;
                font-size: 20px;
                color: #666666;
                font-weight: 400;
                line-height:28px;
            }
            .section_3 {
                margin: 0.11rem 8px 0.053rem;
                background-color: #e0e0e0;
                width: 0.013rem;
                height: 0.21rem;
            }

        }
    }
    div.price-line{
        font-size:24px;
        justify-content: space-between;
        .text_15{
            margin-left:8px;
        }
        .text_16{
            font-size:32px;
        }
        .markIcon{
            display: inline-block;
            border: 1px solid rgba(204,204,204,1);
            border-radius: 8px;
            color: #999999;
            font-size: 0.27rem;
            font-family: 'PingFang SC';
            height:32px;
            line-height: 32px;
            padding:0px 8px;
            margin-left:16px;
            margin-top:6px;
        }
        .text_20{
            font-family: PingFangSC-Regular;
            font-size: 24px;
            color: #999999;
            font-weight: 400;
        }

    }
}
</style>



// WEBPACK FOOTER //
// CarCard.vue?0e87e204